import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'templates/:id',
    loadChildren: () =>
      import('./templates/templates.module').then((m) => m.TemplatesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'main/:id',
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'activity/:id',
    loadChildren: () =>
      import('./view-activity/view-activity.module').then(
        (m) => m.ViewActivityPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'multiple',
    loadChildren: () =>
      import('./multiple/multiple.module').then((m) => m.MultpiplePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
